import { render, staticRenderFns } from "./GGCardBtn.vue?vue&type=template&id=8361cd78&"
import script from "./GGCardBtn.vue?vue&type=script&lang=js&"
export * from "./GGCardBtn.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/atlassian/pipelines/agent/build/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('8361cd78')) {
      api.createRecord('8361cd78', component.options)
    } else {
      api.reload('8361cd78', component.options)
    }
    module.hot.accept("./GGCardBtn.vue?vue&type=template&id=8361cd78&", function () {
      api.rerender('8361cd78', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/Elements/GGCardBtn.vue"
export default component.exports